<template>
  <div class="py-6 md:pb-20">
    <base-headline class="text-xl">{{ title }}</base-headline>

    <div v-if="vimeo" v-html="vimeo.html" :style="vimeoRatio" class="w-full relative"></div>
    <div v-else-if="qq" v-html="qq" style="padding-bottom:56%" class="w-full relative"></div>

    <figcaption v-html="caption" class="text-sm mt-2 mb-6"></figcaption>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import axios from 'axios'

export default {
  name: 'BaseEmbedRow',
  props: {
    row: {
      type: Object,
      required: true
    },
    offset: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      vimeo: null,
      qq: null
    }
  },
  computed: {
    vimeoRatio () {
      if (!this.vimeo) return
      return {
        paddingBottom: `${(this.vimeo.height / this.vimeo.width) * 100}%`
      }
    },
    title () {
      return this.row.title
    },
    caption () {
      return this.row.caption
    }
  },
  methods: {
    vimeoEmbed (url) {
      axios.get(`https://vimeo.com/api/oembed.json?url=${url}`).then(({ data }) => {
        this.vimeo = data
      })
    }
  },
  created () {
    const { url_qq, url_vimeo } = this.row
    if (url_vimeo) {
      this.vimeoEmbed(url_vimeo)
    }
    if (url_qq) {
      const path = url_qq.split('/').pop()
      const vidId = path.split('.').shift()

      // example embed code from QQ
      // <iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=b0814u2sqll" allowFullScreen="true"></iframe>

      const url = `https://v.qq.com/txp/iframe/player.html?vid=${vidId}`
      this.qq = `<iframe src="${url}" allowFullScreen="true"></iframe>`
    }
  }
  // mounted () {
  //   this.$store.commit('HAS_MEDIA', true)
  // },
  // beforeDestroy () {
  //   this.$store.commit('HAS_MEDIA', false)
  // }
}
</script>

<style lang="stylus">
  .w-full iframe
    width: 100%
    height: 100%
    position: absolute
    top: 0
    left: 0
</style>
